module.exports = __webpack_public_path__ + "img/beak-active.8f72688e.svg";